/*
* Responsive video's not longer work in chrome so we load them in depending on the screen size.
*/
function fnResponsiveVideoLoading( i, oSection ) {
	var oVideo = $(oSection);
		sSD = oVideo.data('src'),
		sHD = oVideo.data('hd-src'),
		sULTRAHD = oVideo.data('ultrhd-src'),
		sVideoUrl = "",
		sScreenSize = $(window).width();
		if(sScreenSize >= "1900"){
			sVideoUrl = sULTRAHD;
		}else if(sScreenSize >= "1350"){
			sVideoUrl = sHD;
		}else{
			sVideoUrl = sSD;
		}
		oVideo.append("<source src='"+sVideoUrl+"' type='video/mp4' >");
}
